import React, { useState } from 'react';
import { Form, Input, Button, Typography, message, Card } from 'antd';

const { Title } = Typography;

const PasswordResetForm = () => {
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      // Здесь вызовите ваш API для восстановления пароля
      // await api.post('/api/auth/reset-password', { email: values.email });
      message.success('Инструкция по восстановлению пароля отправлена на ваш email!');
    } catch (error) {
      message.error('Ошибка при отправке письма. Попробуйте ещё раз.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card style={{ maxWidth: 400, margin: '40px auto' }}>
      <Title level={3} style={{ textAlign: 'center' }}>Восстановление пароля</Title>
      <Form
        name="password_reset"
        layout="vertical"
        onFinish={onFinish}
        autoComplete="off"
      >
        <Form.Item
          label="Email"
          name="email"
          rules={[
            { required: true, message: 'Пожалуйста, введите email!' },
            { type: 'email', message: 'Некорректный email!' }
          ]}
        >
          <Input placeholder="Введите ваш email" />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" block loading={loading}>
            Восстановить
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default PasswordResetForm; 